/* To speed the script up, you can set a sampling rate in words. For example, if you set
 * sampleLimit to 1000, only the first 1000 words will be parsed from the input text.
 * Set to 0 to never sample.
 */
const sampleLimit = 1000;

// Manual rewrite of the textstat Python library (https://github.com/shivam5992/textstat/)

/*
 * Regular expression to identify a sentence. No, it's not perfect.
 * Fails e.g. with abbreviations and similar constructs mid-sentence.
 */
const sentenceRegex = new RegExp('[.?!]\\s[^a-z]', 'g');

/*
 * Regular expression to identify a syllable. No, it's not perfect either.
 * It's based on English, so other languages with different vowel / consonant distributions
 * and syllable definitions need a rewrite.
 * Inspired by https://bit.ly/2VK9dz1
 */
const syllableRegex = new RegExp('[aiouy]+e*|e(?!d$|ly).|[td]ed|le$', 'g');

// Baseline for FRE - English only
const freBase = {
  base: 206.835,
  sentenceLength: 1.015,
  syllablesPerWord: 84.6,
  syllableThreshold: 3,
};

const punctuation = [
  '!',
  '"',
  '#',
  '$',
  '%',
  '&',
  "'",
  '(',
  ')',
  '*',
  '+',
  ',',
  '-',
  '.',
  '/',
  ':',
  ';',
  '<',
  '=',
  '>',
  '?',
  '@',
  '[',
  ']',
  '^',
  '_',
  '`',
  '{',
  '|',
  '}',
  '~',
];

const legacyRound = (number: number, precision: number) => {
  const k = Math.pow(10, precision || 0);
  return Math.floor(number * k + 0.5 * Math.sign(number)) / k;
};

// const charCount = (text: string) => {
//   if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
//   text = text.replace(/\s/g, '');
//   return text.length;
// };

const removePunctuation = (text: string) => {
  return text
    .split('')
    .filter(function (c) {
      return punctuation.indexOf(c) === -1;
    })
    .join('');
};

// const letterCount = (text: string) => {
//   if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
//   text = text.replace(/\s/g, '');
//   return removePunctuation(text).length;
// };

const lexiconCount = (text: string) => {
  text = removePunctuation(text);
  const lexicon = text.split(' ').length;
  return lexicon;
};

const getWords = (text: string) => {
  if (sampleLimit > 0) text = text.split(' ').slice(0, sampleLimit).join(' ');
  text = text.toLowerCase();
  text = removePunctuation(text);
  const words = text.split(' ');
  return words;
};

const syllableCount = (text: string) => {
  const syllables = getWords(text).reduce(function (a, c) {
    return a + (c.match(syllableRegex) || [1]).length;
  }, 0);
  return syllables;
};

// const polySyllableCount = (text: string) => {
//   let count = 0;
//   getWords(text).forEach(function (word) {
//     const syllables = syllableCount(word);
//     if (syllables >= 3) {
//       count += 1;
//     }
//   });
//   return count;
// };

const sentenceCount = (text: string) => {
  let ignoreCount = 0;
  const sentences = text.split(sentenceRegex);
  sentences.forEach((s) => {
    if (lexiconCount(s) <= 2) {
      ignoreCount += 1;
    }
  });
  const count = Math.max(1, sentences.length - ignoreCount);
  return count;
};

const avgSentenceLength = (text: string) => {
  const avg = lexiconCount(text) / sentenceCount(text);
  return legacyRound(avg, 2);
};

const avgSyllablesPerWord = (text: string) => {
  const avg = syllableCount(text) / lexiconCount(text);
  return legacyRound(avg, 2);
};

// const avgCharactersPerWord = (text: string) =>  {
//   const avg = charCount(text) / lexiconCount(text);
//   return legacyRound(avg, 2);
// };

// const avgLettersPerWord = (text:string) => {
//   const avg = letterCount(text) / lexiconCount(text);
//   return legacyRound(avg, 2);
// };

// const avgSentencesPerWord = (text:string) => {
//   const avg = sentenceCount(text) / lexiconCount(text);
//   return legacyRound(avg, 2);
// };

export const calculateFleschReadingEase = (
  text: string,
  decimalPlaces: number
): number => {
  const sentenceLength = avgSentenceLength(text);
  const syllablesPerWord = avgSyllablesPerWord(text);
  const fleschScore =
    Math.round(
      (freBase.base -
        freBase.sentenceLength * sentenceLength -
        freBase.syllablesPerWord * syllablesPerWord) *
        10 ** decimalPlaces
    ) /
    10 ** decimalPlaces;
  return fleschScore > 100 || fleschScore < 0 ? 0 : fleschScore;
};

export const calculateReadingTime = (
  text: string,
  decimalPlaces: number
): number => {
  const wordsPerSecond = 4.17;
  // To get full reading time, ignore cache and sample
  return (
    Math.round(
      (lexiconCount(text) / wordsPerSecond / 60) * 10 ** decimalPlaces
    ) /
    10 ** decimalPlaces
  );
};
